module.exports = __webpack_public_path__ + "static/media/awards-cup.61e6764e.md";